// package-channels.ts — (tf3-35a; B-F14) the Channels pages' words for the package's channels, pure: a channel's page
// path, its platform's name, and its status line (the same reconnect prompt Settings shows).
import { reconnectPrompt, type Platform } from "./channel-status.ts";
import { platformName } from "./post-numbers.ts";

export const channelPath = (channelId: string) => `/channels/${encodeURIComponent(channelId)}`;
/** the platform's name, as Disconnect's words name it */
export const platformOf = (channel: string): Platform => platformName(channel) as Platform;
/** Pure: the line under a channel's name: the reconnect prompt when it needs one, otherwise "Connected". */
export const statusLine = (c: { status?: string | null; statusReason?: string | null }): { text: string; reconnect: boolean } => {
  const p = reconnectPrompt(c);
  return p ? { text: p, reconnect: true } : { text: "Connected", reconnect: false };
};
export const NO_CHANNELS = "No channels connected yet. Connect YouTube, TikTok or Instagram on Settings to post from TubeForge.";
export const NO_POSTED_HERE = "Nothing posted to this channel from TubeForge yet.";
/** (audit 10-17-B, B2) the page reads only the most recent published videos: said, so an older post isn't denied */
export const noPostedHere = (looked: number) => (looked < POSTED_VIDEOS_READ ? NO_POSTED_HERE
  : `None of your ${looked} most recent posted videos went to this channel. Older posts aren't read here: open a video for its numbers.`);
export const readScope = (looked: number) => `From your ${looked} most recent posted video${looked === 1 ? "" : "s"}.`;
export const unreadableLine = (n: number) => `${n} video${n === 1 ? "" : "s"}' numbers couldn't be read just now.`;

/** Pure: a video's name in a list (its generated title, else its guidance, else when it was made). */
export function videoLabel(v: { generatedMetadata?: Record<string, unknown> | null; userGuidance?: string | null; createdAt: string | Date }): string {
  const t = v.generatedMetadata?.title;
  if (typeof t === "string" && t.trim()) return t.trim();
  if (v.userGuidance?.trim()) return v.userGuidance.trim().slice(0, 80);
  return `Video of ${new Date(v.createdAt).toLocaleDateString()}`;
}
/** the most recent posted videos a channel's page reads the numbers of */
export const POSTED_VIDEOS_READ = 10;
